<script>
import { mapGetters } from "vuex";
import modalCheckoutPlan from "@/modal/checkout-plan";
export default {
  name: "account",
  computed: {
    ...mapGetters("config", ["userPlan"]),
    ...mapGetters("stores", ["entries"])
  },
  methods: {
    checkoutPlan() {
      let options = {
        parent: this,
        component: modalCheckoutPlan,
        hasModalCard: true
      };
      this.$buefy.modal.open(options);
    }
  }
};
</script>

<template>
  <div class="view">
    <div class="view__head">
      <h2 class="bar__title">Account</h2>
    </div>
    <div class="view__body">
      <div v-if="userPlan" class="content">
        <div>
          Current plan: <b>{{ userPlan.sku }}</b>
        </div>
        <div>
          Expires:
          <b>{{ userPlan.expiry | moment("calendar") }}</b>
        </div>
        <br />
        <div class="buttons">
          <b-button class="is-primary" @click="checkoutPlan()">
            Renew / Upgrade
          </b-button>
        </div>
      </div>
      <div v-else class="content">
        <div>
          <p>Current plan: <b>Free</b></p>
          <b-button class="is-primary" @click="checkoutPlan()">
            Add a Plan
          </b-button>
        </div>
      </div>
      <hr />
      <div class="content">
        You have <b>{{ entries.length }}</b> stores of
        <b>{{ userPlan.includes.stores }}</b> allowed in your plan.
      </div>
    </div>
  </div>
</template>
